module.exports = __webpack_public_path__ + "static/media/Apple-pages.af7947fa.png";